import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Box, ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { HelmetProvider } from "react-helmet-async";

import Home from "./pages/Home";
import ProfilePage from "./pages/ProfilePage";
import CheckPPPage from "./pages/CheckPPPage";
import ConvertPPPage from "./pages/ConvertPPPage";
import CheckHRPage from "./pages/CheckHRPage";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import { AuthProvider } from "./context/AuthContext";
import AdminPage from "./admin/AdminPage";
import AdminPageManager from "./admin/AdminPageManager";
import Footer from "./components/Footer";
import ContactsPage from "./pages/ContactsPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import ScrollToTop from "./components/ScrollToTop";
import AnalyticsTracker from "./components/AnalyticsTracker";
import DownloadsPage from "./pages/DownloadsPage";
import "./PageLayout.css";

const theme = createTheme({
    typography: {
        fontFamily: [
            "Manrope",
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "sans-serif",
        ].join(","),
    },
});

function App() {
    return (
        <HelmetProvider>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <Router
                    future={{
                        v7_startTransition: true,
                        v7_relativeSplatPath: true,
                    }}
                >
                    <AuthProvider>
                        <AnalyticsTracker />
                        <ScrollToTop />

                        <Box
                            sx={{
                                minHeight: "100vh",
                                display: "flex",
                                flexDirection: "column",
                                bgcolor: "#f8fafc",
                            }}
                        >
                            <Navbar />

                            <Box sx={{ flex: 1 }}>
                                <Routes>
                                    <Route path="/" element={<Home />} />

                                    <Route
                                        path="/adminpanel/*"
                                        element={
                                            <ProtectedRoute requiredRole="admin">
                                                <AdminPage />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path="/manager/*"
                                        element={
                                            <ProtectedRoute requiredRole="manager">
                                                <AdminPageManager />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route path="/check-pp" element={<CheckPPPage />} />
                                    <Route path="/check-hr" element={<CheckHRPage />} />
                                    <Route path="/convert-pp" element={<ConvertPPPage />} />
                                    <Route path="/contacts" element={<ContactsPage />} />
                                    <Route path="/privacy" element={<PrivacyPage />} />
                                    <Route path="/terms" element={<TermsPage />} />
                                    <Route path="/downloads" element={<DownloadsPage />} />

                                    <Route
                                        path="/profile"
                                        element={
                                            <ProtectedRoute requiredRole="user">
                                                <ProfilePage />
                                            </ProtectedRoute>
                                        }
                                    />

  
                                </Routes>
                            </Box>

                            <Footer />
                        </Box>
                    </AuthProvider>
                </Router>
            </ThemeProvider>
        </HelmetProvider>
    );
}

export default App;